<template>
<div class="row">
  <div class="col-12 text-left">
    <h2>{{$t('message.remarks.title_remark_editor')}}</h2>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <select multiple class="form-control" :disabled="mode === MODE_EDIT || mode === MODE_NEW" >
        <option v-for="rt in remarkList" :key="rt.name" @click="remarkClick(rt)">{{rt.name}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <bs-input v-model="name" :placeholder="$t('message.remarks.name')"  :disabled="mode === MODE_NORMAL"></bs-input>
      <bs-input v-model="remarkText" type="textarea" :placeholder="$t('message.remarks.remark')" :disabled="mode === MODE_NORMAL"></bs-input>
    </div>
  </div>

  <div class="col-12 text-left">
    <button class="btn btn-close btn-lg btn-space" @click="closeEditor">{{this.$t('action_message.close')}}</button>
    <button class="btn btn-store btn-lg btn-space" @click="saveEditor">{{this.$t('action_message.save')}}</button>
    <button v-if="mode === MODE_EDIT || mode === MODE_NEW" class="btn btn-cancel btn-lg float-right btn-space" @click="cancelMode">{{this.$t('action_message.cancel')}}</button>
    <button v-if="mode === MODE_EDIT || mode === MODE_NEW" class="btn btn-store btn-lg float-right btn-space" @click="saveRemarks">{{this.$t('action_message.ok')}}</button>
    <button v-if="mode === MODE_NORMAL && remarkObj !== null" class="btn btn-delete btn-lg float-right btn-space" @click="deleteRemark">{{this.$t('action_message.remove')}}</button>
    <button v-if="enableEditMode" class="btn btn-store btn-lg float-right btn-space" @click="gotoEditMode">{{this.$t('action_message.edit')}}</button>
    <button v-if="mode === MODE_NORMAL" class="btn btn-store btn-lg float-right btn-space" @click="gotoNewMode">{{this.$t('action_message.add')}}</button>
  </div>
</div>
</template>

<script>

import jq from 'jquery'
import Multiselect from 'vue-multiselect'
import { input as BsInput } from 'vue-strap'

export default {
  components: {
    jq,
    Multiselect,
    BsInput
  },
  props: {
    valueRemarks: {
      type: Array,
      default: []
    }
  },
  data () {
    let MODE_NORMAL = 0
    let MODE_EDIT = 1
    let MODE_NEW = 2
    return {
      MODE_NORMAL: MODE_NORMAL,
      MODE_EDIT: MODE_EDIT,
      MODE_NEW: MODE_NEW,
      name: null,
      remarkText: null,
      remarkObj: null,
      mode: MODE_NORMAL,
      remarkList: this.valueRemarks
    }
  },
  computed: {
    enableEditMode () {
      return this.mode === this.MODE_NORMAL && this.remarkObj !== null
    }
  },
  methods: {
    remarkClick (remarkObj) {
      if (this.mode === this.MODE_NORMAL) {
        this.name = remarkObj.name
        this.remarkText = remarkObj.text
        this.remarkObj = remarkObj
      }
    },
    closeEditor () {
      this.$emit('closeEditor')
    },
    saveRemarks () {
      if (this.mode === this.MODE_EDIT) {
        this.remarkObj.name = this.name
        this.remarkObj.text = this.remarkText
      } else if (this.mode === this.MODE_NEW) {
        this.remarkList.push({name: this.name, text: this.remarkText})
        this.remarkObj = null
        this.name = null
        this.remarkText = null
      }
      this.mode = this.MODE_NORMAL
    },
    gotoEditMode () {
      this.mode = this.MODE_EDIT
    },
    deleteRemark () {
      this.remarkList = this.remarkList.filter(r => r.name !== this.remarkObj.name)
    },
    cancelMode () {
      this.mode = this.MODE_NORMAL
      this.remarkObj = null
      this.name = null
      this.remarkText = null
    },
    gotoNewMode () {
      this.mode = this.MODE_NEW
      this.remarkObj = null
      this.name = null
      this.remarkText = null
    },
    saveEditor () {
      this.$emit('comment-updated', this.remarkList)
      this.$emit('submitRemark')
      this.$emit('closeEditor')
    }
  },
  watch: {
    values (v, o) {
      this.remarkList = v
    },
    valueRemarks: function (newVal, oldVal) { // watch it
      this.remarkList = newVal
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

.btn-space {
  margin-left: 5px;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// RemarkEditor.vue?64467d86